<template>
  <main class="content">
    <!-- content -->
    <section class="intro">
      <div class='container'>

        <div class="intro__wrapper">
          <div class="intro__text text-intro">
            <h1 class="text-intro__title">{{group.name}}</h1>
            <p class="text-intro__subtitle" v-if="group.cf[475]">{{group.cf[475]}}</p>
            <a class="intro__link" v-if="group.cf[476]" @click="$root.requestModal = 1, $root.modalText = '<iframe src=\''+group.cf[476]+'\'></iframe>'">
              <picture><source srcset="/static/img/intro/play.svg" type="image/webp"><img src="/static/img/intro/play.svg" alt="" /></picture>
              <span>Как это происходит?</span>
            </a>
          </div>
          <div class="intro__image">
            <picture><source srcset="/static/img/intro/vector.svg" type="image/webp"><img src="/static/img/intro/vector.svg" alt="" /></picture>
          </div>
        </div>
      </div>
    </section>

    <section class="risk">
      <div class='container'>
        <div class="risk__wraper">

          <div class="risk__items">
            <div class="risk__item">
              <div class="risk__picture">
                <picture><source srcset="/static/img/risk/1.svg" type="image/webp"><img src="/static/img/risk/1.svg" alt="" /></picture>
              </div>
              <div class="risk__text" v-if="group.cf[489]">{{group.cf[489]}}</div>
              <div class="risk__text" v-else>Получаете комплект необходимых документов чтобы выиграть свое дело. Готовите их по нашим шаблонам или доверяете подготовку нам.</div>
            </div>
            <div class="risk__item">
              <div class="risk__picture">
                <picture><source srcset="/static/img/risk/2.svg" type="image/webp"><img src="/static/img/risk/2.svg" alt="" /></picture>
              </div>
              <div class="risk__text" v-if="group.cf[490]">{{group.cf[490]}}</div>
              <div class="risk__text" v-else>У вас будет чёткая инструкция действий.Идете с этими документами в суд или решаете в досудебном порядке</div>
            </div>
            <div class="risk__item">
              <div class="risk__picture">
                <picture><source srcset="/static/img/risk/3.svg" type="image/webp"><img src="/static/img/risk/3.svg" alt="" /></picture>
              </div>
              <div class="risk__text" v-if="group.cf[491]">{{group.cf[491]}}</div>
              <div class="risk__text" v-else>Выигрываете дело. Без рисков и затрат на юристов</div>
            </div>
          </div>
        </div>
      </div>
    </section>

    <section class="info" v-if="group.cf[477] || group.cf[478] || group.cf[479]">
      <div class='container'>
        <div class="info__wrapper">
          <h2 class="info__title">Как выигрываются дела</h2>
          <div class="info__inner">
            <div class="swiper-container">
              <!-- Additional required wrapper -->
              <div class="swiper-wrapper">
                <!-- Slides -->
                <div class="swiper-slide" v-if="group.cf[477]">
                  <div class="info__item">
                    <div class="info__number"><span>1</span></div>
                    <div class="info__text">
                      <p>{{group.cf[477]}}</p>
                    </div>
                  </div>
                </div>
                <div class="swiper-slide" v-if="group.cf[478]">
                  <div class="info__item">
                    <div class="info__number"><span>2</span></div>
                    <div class="info__text">
                      <p>{{group.cf[478]}}</p>
                    </div>
                  </div>
                </div>
                <div class="swiper-slide" v-if="group.cf[479]">
                  <div class="info__item">
                    <div class="info__number"><span>3</span></div>
                    <div class="info__text">
                      <p>{{group.cf[479]}}</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>

    <section class="accordion">
      <div class='container'>
        <div class="accordion__wrapper">
          <h1 class="accordion__title">Выберите свою ситуацию</h1>
          <div class="accordion__box box-accordion">
            <div class="accordion__item item-accordion" v-for="groupc in groups" :key="groupc.id" v-if="parseInt(group.id) === 549">
              <h1 class="item-accordion__header">{{groupc.name}}</h1>
              <ul class="item-accordion__body">
                <li class="item-accordion__content" v-for="service in services" :key="service.id" v-if="parseInt(service.cf[341]) === groupc.id">
                  <span class="item-accordion__number">{{service.cf[342]}}</span>
                  <span class="item-accordion__text">{{service.name}}</span>
                  <router-link :to="'/services/' + service.id">
                    <picture>
                      <source srcset="/static/img/accordion/more.svg" type="image/webp">
                      <img src="/static/img/accordion/more.svg" alt="" />
                    </picture>
                  </router-link>
                </li>
              </ul>
            </div>
            <div class="accordion__item item-accordion" v-for="groupc in groups" :key="groupc.id" v-if="parseInt(group.id) === parseInt(groupc.cf[532])">
              <h1 class="item-accordion__header">{{groupc.name}}</h1>
              <ul class="item-accordion__body">
                <li class="item-accordion__content" v-for="service in services" :key="service.id" v-if="parseInt(service.cf[495]) === groupc.id">
                  <span class="item-accordion__number">{{service.cf[494]}}</span>
                  <span class="item-accordion__text">{{service.name}}</span>
                  <router-link :to="'/service/' + service.id">
                    <picture>
                      <source srcset="/static/img/accordion/more.svg" type="image/webp">
                      <img src="/static/img/accordion/more.svg" alt="" />
                    </picture>
                  </router-link>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </section>

    <section class="black black-margin black-category" v-if="group.cf[480] || group.cf[481] || group.cf[482] || group.cf[483]">
      <div class='container'>
        <div class="black__wrapper">
          <div class="black__inner inner-black">
            <slot v-if="group.cf[480] || group.cf[481]">
            <h1 class="inner-black__text" v-if="group.cf[480]">{{group.cf[480]}}</h1>
            <p class="inner-black__subtext" v-if="group.cf[481]">{{group.cf[481]}}</p>
            </slot>
            <div class="black__white white-black" v-if="group.cf[482] || group.cf[483]">
              <h1 class="white-black__text" v-if="group.cf[482]">{{group.cf[482]}}</h1>
              <ol class="white-black__list" v-if="group.cf[483]">
                <li class="white-black__link" v-if="cf" v-for="(cf, i) in group.cf[483].split('\n')" :key="i">{{cf}}</li>
              </ol>
              <div class="black__btn-wrapper">
                <a href="#formSelect" class="black__btn">Получить документы</a>
              </div>
            </div>
          </div>

        </div>
      </div>
    </section>

    <section class="document">
      <div class='container'>
        <div class="document__wrapper">
          <div class="document__inner">
            <div class="document__list list-document">
                <h1 class="document__title">Для кого</h1>
              <ul class="list-document__ul">
                <li class="list-document__link" v-if="group.cf[484]">{{group.cf[484]}}</li>
                <li class="list-document__link" v-else>Для тех, кому предстоит суд по любой возникшей проблеме</li>
                <li class="list-document__link" v-if="group.cf[485]">{{group.cf[485]}}</li>
                <li class="list-document__link" v-else>Для тех, кто хочет решить вопрос в досудебном порядке</li>
                <li class="list-document__link" v-if="group.cf[486]">{{group.cf[486]}}</li>
                <li class="list-document__link" v-else>Для тех, кто сомневается в качестве работы своего юриста или просто хочет проверить его работу</li>
                <li class="list-document__link" v-if="group.cf[487]">{{group.cf[487]}}</li>
                <li class="list-document__link" v-else>Для начинающих юристов, помощников юристов и студентов</li>
                <li class="list-document__link" v-if="group.cf[488]">{{group.cf[488]}}</li>
              </ul>
            </div>
            <div class="document__form form-document">
              <div id="formSelect">
                <div class="form-document__wrapper">
                  <div class="form-document__select-box" style="flex: 0 1 100%;margin-right: 0;">
                    <div :class="selectGroup.show?'nice-select select-block open':'nice-select select-block'" @click="selectGroup.show=1" @focusout="selectGroup.show=0" tabindex="0">
                      <span class="current">{{selectGroup.name?selectGroup.name:'Выберите группу'}}</span>
                      <ul class="list">
                        <li v-for="group in groups" :key="group.id" :class="selectGroup.id===group.id?'option selected focus':'option'" @click="selectGroup.id = group.id, selectGroup.name = group.name">
                          {{group.name}}</li>
                      </ul>
                    </div>
                  </div>
                  <div class="form-document__select-box" style="flex: 0 1 100%;margin-right: 0;" v-show="parseInt(selectGroup.id)">
                    <div :class="selectService.show?'nice-select select-block open':'nice-select select-block'" @click="selectService.show=1" @focusout="selectService.show=0" tabindex="0">
                      <span class="current">{{selectService.name?selectService.name:'Выберите статью'}}</span>
                      <ul class="list" v-if="549 === parseInt(group.id)">
                        <li v-for="service in services" :key="service.id" :class="selectService.id===service.id?'option selected focus':'option'"  v-if="parseInt(service.cf[341]) === parseInt(selectGroup.id)" @click="selectService.id = service.id, selectService.name = service.name, price = (selectService.name.toLowerCase().indexOf('ходатайства'))?299:0">
                          {{service.cf[403]}}</li>
                      </ul>
                      <ul class="list" v-else>
                        <li v-for="service in services" :key="service.id" :class="selectService.id===service.id?'option selected focus':'option'"  v-if="parseInt(service.cf[495]) === parseInt(selectGroup.id)" @click="selectService.id = service.id, selectService.name = service.name">
                          {{service.cf[492]}}</li>
                      </ul>
                    </div>
                  </div>
                  <div class="form-document__select-box">
                    <input autocomplete="off" type="text" name="form[]" class="form-document__input" placeholder="Город" v-model="city"/>
                  </div>
                  <div class="form-document__input-box">
                    <input autocomplete="off" type="text" name="form[]" class="form-document__input" placeholder="Имя" v-model="name"/>
                  </div>
                  <div class="form-document__input-box box-input-margin">
                    <input autocomplete="off" type="tel" name="form[]" class="form-document__input" placeholder="Телефон" v-model="phone" data-inputmask="'mask': '+7(999)999-99-99'" />
                  </div>
                  <div class="form-document__input-box">
                    <input autocomplete="off" type="email" name="form[]" class="form-document__input" placeholder="E-mail" v-model="email" data-inputmask="'alias': 'email'"/>
                  </div>
                  <div class="form-document__btn-wrapper">
                    <button class="form-document__btn" @click="sendQuestion">Получить документы</button>
                  </div>
                </div>

              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  </main>
</template>

<script>
  import axios from '@/router/http'
  import Inputmask from 'inputmask'
  export default {
    name: 'group',
    data () {
      return {
        group: { cf: {} },
        groups: [],
        services: [],
        selectGroup: {id: null, show: 0, name: null},
        selectService: {id: null, show: 0, name: null},
        name: null,
        email: null,
        phone: null,
        city: null,
        price: null
      }
    },
    methods: {
      initPage () {
        axios.get('https://bez.v-avtoservice.com/list/get-listc?id=' + this.$route.params.id).then(response => {
          this.group = response.data
          if (!this.group.cf) this.group.cf = {}
          if (parseInt(this.$route.params.id) === 549) {
            axios.get('https://urist1.v-avtoservice.com/list/get-lists?id=31').then(response => {
              this.groups = response.data
            })
            axios.get('https://urist1.v-avtoservice.com/list/get-lists?id=32').then(response => {
              this.services = response.data

              setTimeout(() => {
                this.initSlider()
              }, 1000)
            })
          } else {
            axios.get('https://bez.v-avtoservice.com/list/get-lists?id=40').then(response => {
              this.groups = response.data
            })
            axios.get('https://bez.v-avtoservice.com/list/get-lists?id=39').then(response => {
              this.services = response.data

              setTimeout(() => {
                this.initSlider()
              }, 1000)
            })
          }
        })
      },
      initSlider () {
        // eslint-disable-next-line
        new Swiper('.swiper-container', {
          loop: false,
          observer: true,
          observeParents: true,
          slidesPerView: 3,
          spaceBetween: 0,
          speed: 800,
          breakpoints: {
            320: {
              slidesPerView: 'auto',
              spaceBetween: 0
            },
            376: {
              slidesPerView: 1
            },
            767: {
              slidesPerView: 2
            },
            992: {
              slidesPerView: 3
            },
            1292: {
              slidesPerView: 3
            }
          }
        })
      },
      sendQuestion () {
        if (!this.email) alert('Вам необходимо указать E-mail')
        if (!this.phone) alert('Вам необходимо указать Телефон')
        else if (!this.selectGroup.name) alert('Вам необходимо выбрать группу')
        else if (!this.selectService.name) alert('Вам необходимо выбрать статью')
        else {
          if (this.selectService.name.toLowerCase().indexOf('ходатайства') >= 0) {
            this.price = 0
          } else this.price = 299
          if (parseInt(this.group.id) === 549) {
            var formData = new FormData()
            formData.append('crm', '9')
            formData.append('pipe', '17')
            formData.append('contact[name]', this.name)
            formData.append('contact[141]', this.phone)
            formData.append('contact[142]', this.email)
            formData.append('contact[143]', this.city)
            formData.append('lead[147]', this.city)
            formData.append('lead[146]', this.selectGroup.name)
            formData.append('lead[145]', this.selectService.name)
            formData.append('lead[price]', this.price)
            axios.post('https://urist1.v-avtoservice.com/api/import-lead',
              formData,
              {
                headers: {
                  'Content-Type': 'multipart/form-data'
                }
              }
            ).then(res => {
              if (res.data.link.result.payment_link) window.location.href = res.data.link.result.payment_link
              else alert('Спасибо, ваша заявка отправлена')
            })
          } else {
            var formDatas = new FormData()
            formDatas.append('crm', '16')
            formDatas.append('pipe', '34')
            formDatas.append('contact[name]', this.name)
            formDatas.append('contact[466]', this.phone)
            formDatas.append('contact[467]', this.email)
            formDatas.append('lead[price]', this.price)
            formDatas.append('contact[473]', this.city)
            formDatas.append('lead[471]', this.city)
            formDatas.append('lead[534]', this.group.name)
            formDatas.append('lead[468]', this.selectGroup.name)
            formDatas.append('lead[469]', this.selectService.name)
            axios.post('https://bez.v-avtoservice.com/api/import-lead',
              formDatas,
              {
                headers: {
                  'Content-Type': 'multipart/form-data'
                }
              }
            ).then(res => {
              if (res.data.link.result.payment_link) window.location.href = res.data.link.result.payment_link
              else alert('Спасибо, ваша заявка отправлена')
            })
          }
        }
      }
    },
    mounted () {
      this.initPage()
      Inputmask().mask(document.querySelectorAll('input'))
      setTimeout(() => {
        Inputmask().mask(document.querySelectorAll('input'))
      }, 1000)
      $(document).on('click.accordion', '.item-accordion__header', function () {
        var parent = $(this).parent()
        if (parent.hasClass('active')) {
          parent.removeClass('active')
        } else {
          $('.accordion__item').removeClass('active')
          parent.addClass('active')
        }
      })
    },
    beforeDestroy () {
      $(document).unbind('click.accordion')
    },
    watch: {
      $route (to, from) {
        this.initPage()
      },
      'selectGroup.id' (val, oldVal) {
        if (val !== oldVal) {
          setTimeout(() => {
            this.selectGroup.show = 0
          }, 100)
        }
      },
      'selectService.id' (val, oldVal) {
        if (val !== oldVal) {
          setTimeout(() => {
            this.selectService.show = 0
          }, 100)
        }
      }
    }
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/group.vue